import { Widget } from '../widget/widget';

export class DateWidget extends Widget {
    constructor(node, args = {}) {
        super(node, args);
    }

    async validate() {
        this.clearError();
        let valid = true;

        // TODO add regex filters
        if (this.required && this.$input.value.length === 0) {
            this.displayError('widget.is_required');
            valid = false;
        }

        /*console.log(`Date is valid? ${valid}`);
        console.log(this.$input.value);*/

        return valid;
    }

    async getValue() {
        return this.$input.value;
    }
}
